import React from "react"
import { createStyles, forwardRef } from "@design-system/styled-system"
import { Box } from "./Box"
import { GridProps, GridItemProps, GridSpan } from "./types"

export const Grid = forwardRef<GridProps, "div">((props, ref) => {
  const {
    area,
    templateAreas,
    gap,
    rowGap,
    columnGap,
    column,
    row,
    autoFlow,
    autoRows,
    templateRows,
    autoColumns,
    templateColumns,
    style,
    ...rest
  } = props

  const styleProps = {
    gridArea: area,
    gridTemplateAreas: templateAreas,
    gridGap: gap,
    gridRowGap: rowGap,
    gridColumnGap: columnGap,
    gridAutoColumns: autoColumns,
    gridColumn: column,
    gridRow: row,
    gridAutoFlow: autoFlow,
    gridAutoRows: autoRows,
    gridTemplateRows: templateRows,
    gridTemplateColumns: templateColumns,
  }

  return (
    <Box {...styleProps} {...rest} style={[styles.grid, style]} ref={ref} />
  )
})
Grid.displayName = "Grid"

function getSpanStyle(spanValue?: GridSpan) {
  if (!spanValue) {
    return undefined
  }
  return spanValue === "auto" ? "auto" : `span ${spanValue}/span ${spanValue}`
}

export const GridItem = forwardRef<GridItemProps, "div">((props, ref) => {
  const {
    colSpan,
    colStart,
    colEnd,
    rowEnd,
    rowSpan,
    rowStart,
    ...rest
  } = props

  return (
    <Box
      {...rest}
      ref={ref}
      gridColumn={getSpanStyle(colSpan)}
      gridRow={getSpanStyle(rowSpan)}
      gridColumnStart={colStart}
      gridColumnEnd={colEnd}
      gridRowStart={rowStart}
      gridRowEnd={rowEnd}
    />
  )
})
GridItem.displayName = "GridItem"

const styles = createStyles((theme) => ({
  grid: {
    display: "grid",
  },
}))
